'use es6';

export default (() => {
  const element = document.getElementById('page-not-loading');

  if (!element) {
    return;
  }

  element.parentNode.removeChild(element);
});